import { render, staticRenderFns } from "./history.vue?vue&type=template&id=73cc7b54&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=73cc7b54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc7b54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cc7b54')) {
      api.createRecord('73cc7b54', component.options)
    } else {
      api.reload('73cc7b54', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=73cc7b54&scoped=true", function () {
      api.rerender('73cc7b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/Historical/history.vue"
export default component.exports